import { schema } from "normalizr";

const reminder = new schema.Entity(`reminders`);
const arrayOfReminders = [reminder];

export { reminder, arrayOfReminders };
